// Pagina iniziale in base al ruolo
export const homeFor = (role) => (role === "admin" ? "/admin" : role === "teacher" ? "/docente" : "/dashboard");
